export default __webpack_public_path__ + "static/media/BackgroundWhiteNOTRUCK.49d46020.png";